import { i18n } from '../../../../../../shared/helpers/i18n';
import { safeDrawMedia } from '../draw-helpers';
import { getImage } from '../draw-images';
import {
    CONFERENCE_FONT,
    CONFERENCE_MAX_TEXT_WIDTH_RATIO,
    CONFERENCE_START_Y,
    getColors,
    LOGO_HEIGHT,
    LOGO_WIDTH,
    LOGO_X,
    LOGO_Y,
    PICTURE_HEIGHT,
    PICTURE_WIDTH,
    PICTURE_X,
    PICTURE_Y,
    TEXT_FONT,
    TEXT_START_Y,
    TITLE_FONT,
    TITLE_START_Y,
} from './constants';
import { createTruncateText } from './helpers';

const truncateTextWithEllipsis = createTruncateText();

interface DrawAloneScreenParams {
    meetingName?: string;
    callNumber: string;
}

export function drawAloneScreen(
    ctx: CanvasRenderingContext2D,
    { meetingName, callNumber }: DrawAloneScreenParams
): void {
    ctx.save();
    ctx.fillStyle = getColors().background;
    ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);

    const logoFullRu = getImage('logoFullRu');
    const aloneScreenPicture = getImage('aloneScreenPicture');

    if (logoFullRu) {
        safeDrawMedia(ctx, { x: LOGO_X, y: LOGO_Y, width: LOGO_WIDTH, height: LOGO_HEIGHT }, logoFullRu, {
            mode: 'contain',
            verticalAlign: 'center',
            horizontalAlign: 'center',
        });
    }

    if (aloneScreenPicture) {
        safeDrawMedia(
            ctx,
            {
                x: PICTURE_X,
                y: PICTURE_Y,
                width: PICTURE_WIDTH,
                height: PICTURE_HEIGHT,
            },
            aloneScreenPicture,
            { mode: 'contain', verticalAlign: 'center', horizontalAlign: 'center' }
        );
    }

    ctx.fillStyle = getColors().title;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'top';
    ctx.font = TITLE_FONT;
    const title = `${i18n('room-agent', 'alone-screen-title-first-line')} \
${i18n('room-agent', 'alone-screen-title-second-line')}`;
    ctx.fillText(title, ctx.canvas.width / 2, TITLE_START_Y);

    ctx.fillStyle = getColors().text;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'top';
    ctx.font = TEXT_FONT;
    const text = `${i18n('room-agent', 'alone-screen-text-first-line')} \
${i18n('room-agent', 'alone-screen-text-second-line')}`;
    ctx.fillText(text, ctx.canvas.width / 2, TEXT_START_Y);

    ctx.fillStyle = getColors().conference;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'top';
    ctx.font = CONFERENCE_FONT;
    const textWithNameOrId = meetingName
        ? truncateTextWithEllipsis(ctx, meetingName, ctx.canvas.width * CONFERENCE_MAX_TEXT_WIDTH_RATIO)
        : `${i18n('conferences-history', 'conf-number')} ${callNumber}`;
    ctx.fillText(textWithNameOrId, ctx.canvas.width / 2, CONFERENCE_START_Y);

    ctx.restore();
}
